import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '@/api/client';

export interface ClearLoginAttemptsResponse {
    deletedCount: number;
}

export interface SendPasswordResetResponse {
    success: boolean;
    message: string;
}

export function useClearLoginAttempts() {
    const queryClient = useQueryClient();

    return useMutation<ClearLoginAttemptsResponse, Error, number>({
        mutationFn: (userId) =>
            api.post(`/api/admin/users/${userId}/clear-login-attempts`),
        onSuccess: (_, userId) => {
            // Invalidate security query to refresh data
            queryClient.invalidateQueries({
                queryKey: ['admin', 'users', userId, 'security'],
            });
            // Invalidate admin users list to refresh failedLoginAttempts count
            queryClient.invalidateQueries({ queryKey: ['admin', 'users'] });
        },
    });
}

export function useSendPasswordReset() {
    const queryClient = useQueryClient();

    return useMutation<SendPasswordResetResponse, Error, number>({
        mutationFn: (userId) =>
            api.post(`/api/admin/users/${userId}/send-password-reset`),
        onSuccess: (_, userId) => {
            // Invalidate security query to refresh tokens
            queryClient.invalidateQueries({
                queryKey: ['admin', 'users', userId, 'security'],
            });
            // Invalidate admin users list to refresh hasActivePasswordResetToken
            queryClient.invalidateQueries({ queryKey: ['admin', 'users'] });
        },
    });
}
